import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "39",
  height: "39",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "37.406",
  height: "37.406",
  x: "1.215",
  y: ".797",
  fill: "url(#a)",
  stroke: "#9E9E9E",
  "stroke-width": ".594",
  rx: "18.703"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "a",
    width: "1",
    height: "1",
    patternContentUnits: "objectBoundingBox"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      "xlink:href": "#b",
      transform: "translate(-.25)scale(.00588)"
    })
  ]),
  /*#__PURE__*/_createElementVNode("image", {
    "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP8AAACqCAIAAADtKQ7ZAAADnklEQVR4Ae3UsQ0AMQzDwOy/tNNqB97ji7SkCb17z89A04D0Gega6JI31w71GlA/A10DXfLdAO+mAfUz0DXQJW+uHeo1oH4Guga65LsB3k0D6mega6BL3lw71GtA/Qx0DXTJdwO8mwbUz0DXQJe8uXao14D6Gega6JLvBng3Daifga6BLnlz7VCvAfUz0DXQJd8N8G4aUD8DXQNd8ubaoV4D6mega6BLvhvg3TSgfga6BrrkzbVDvQbUz0DXQJd8N8C7aUD9DHQNdMmba4d6Daifga6BLvlugHfTgPoZ6BrokjfXDvUaUD8DXQNd8t0A76YB9TPQNdAlb64d6jWgfga6BrrkuwHeTQPqZ6BroEveXDvUa0D9DHQNdMl3A7ybBtTPQNdAl7y5dqjXgPoZ6Broku8GeDcNqJ+BroEueXPtUK8B9TPQNdAl3w3wbhpQPwNdA13y5tqhXgPqZ6BroEu+G+DdNKB+BroGuuTNtUO9BtTPQNdAl3w3wLtpQP0MdA10yZtrh3oNqJ+BroEu+W6Ad9OA+hnoGuiSN9cO9RpQPwNdA13y3QDvpgH1M9A10CVvrh3qNaB+BroGuuS7Ad5NA+pnoGugS95cO9RrQP0MdA10yXcDvJsG1M9A10CXvLl2qNeA+hnoGuiS7wZ4Nw2on4GugS55c+1QrwH1M9A10CXfDfBuGnjnY6BqQP3Vy+O+U78KugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga0D93dsjV78GugbU3709cvVroGtA/d3bI1e/BroG1N+9PXL1a6BrQP3d2yNXvwa6BtTfvT1y9Wuga+ADujJtFDXIVe4AAAAASUVORK5CYII=",
    id: "b",
    width: "255",
    height: "170"
  })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }